/**
 * @package headstarter
 * @since headstarter 0.2
 */
import CompatObjectFit from "./CompatObjectFit";
import MainNavigation from "./MainNavigation";
import ScrollObserver from "./ScrollObserver";
import SoftScroll from "./SoftScroll";
import WindowEvents from "./WindowEvents";

(function($, window, document, undefined ) {
	WindowEvents.init();
	MainNavigation.init();
	SoftScroll.init();
	ScrollObserver.init();
	var $window = $(window);
	var $navigation = $('#main-navigation');
	//Mobile main menu toggle
	var $toggle = $navigation.find('.menu-toggle');
	if (!$toggle.data('toggle-selector')) {
		$toggle.data('toggle-selector', 'body');
	}
	if (!$toggle.data('toggle-class')) {
		$toggle.data('toggle-class', 'menu-toggled');
	}
	$toggle.on('click', function(){
		$window.triggerHandler('hs:menu-toggle');
		$window.trigger('theme:menu-toggle');
	});
	$window.on('theme:menu-toggle', $.proxy(function(){
		$($(this).data('toggle-selector')).toggleClass($(this).data('toggle-class'));
		$window.triggerHandler('hs:menu-was-toggled');
		$window.trigger('theme:menu-was-toggled');
	}, $toggle));
	$window.on('theme:menu-set-toggled', $.proxy(function(){
		$($(this).data('toggle-selector')).addClass($(this).data('toggle-class'));
		$window.triggerHandler('hs:menu-was-toggled');
		$window.trigger('theme:menu-was-toggled');
	}, $toggle));
	$window.on('theme:menu-unset-toggled', $.proxy(function(){
		$($(this).data('toggle-selector')).removeClass($(this).data('toggle-class'));
		$window.triggerHandler('hs:menu-was-toggled');
		$window.trigger('theme:menu-was-toggled');
	}, $toggle));
	$window.on('theme:menu-toggle-initial', $.proxy(function(){
		if ($(this).data('toggle-initial')) {
			$window.triggerHandler('hs:menu-set-toggled');
			$window.trigger('theme:menu-set-toggled');
		} else {
			$window.triggerHandler('hs:menu-unset-toggled');
			$window.trigger('theme:menu-unset-toggled');
		}
	}, $toggle));
	$window.on('theme:menu-was-toggled', function () {
		$window.trigger('resize');
	});
	$window.triggerHandler('hs:menu-toggle-initial');
	$window.trigger('theme:menu-toggle-initial');
	//Responsive embeds
	$('.entry-content>p').children('iframe,embed,object').wrap('<div class="headstarter-responsive-embed"></div>');

	// Handle Custom Header videos
	$( document ).on( 'wp-custom-header-video-loaded', function() {
		var $video = $( '#wp-custom-header-video' );
		$video.attr( 'playsinline', "" ); // Make sure the video doesn't go in fullscreen mode
		$video.attr( 'muted', "" );
		// To make a video not loop: $video.attr( 'loop', false );
		$video.addClass( "cover-parent" );
		$( window ).on( "touchstart.headerVideoPlay", function() {
			// Older iOs doesn't play the video automatically, so we let it play on first touch event.
			$( window ).off( "touchstart.headerVideoPlay" );
			$video.get(0).play();
		} );
		$video.on( "play", function () {
			$("body").addClass( "header-video-playing" );
		} );
		$video.on( "ended", function() {
			$( window ).off( "touchstart.headerVideoPlay" );
			$("body").removeClass( "header-video-playing" );
		} );
	});

	// Polyfill for object-fit: cover
	CompatObjectFit.addElements( ".cover-parent" );
	CompatObjectFit.init();
})( jQuery, window, document );
